module.exports = __webpack_public_path__ + "img/spoken-training-word.657139e0.svg";